const types = {
  SET_SYS: 'system/SET_SYS',
  SET_SYSNO: 'system/SET_SYSNO',
  SET_SYSID: 'system/SET_SYSID',
  SET_SYSTITLE: 'system/SET_SYSTITLE',
  SET_SETTING: 'system/SET_SETTING',
  SET_ENROLL: 'system/SET_ENROLLINFO',
  SET_OPTIONFLAG: 'system/SET_OPTIONFLAG',
  SET_OPTIONID: 'system/SET_OPTIONID'
}

const state = {
  sysInfo: {
    sysNo: '',
    sysId: 0,
    tytle: ''
  },
  settingInfo: null,
  enrollInfo: null,
  optionFlag: false,
  optionId: 0
}

const getters = {
  getSysInfo: state => {
    return state.sysInfo
  },
  getSysId: state => {
    return state.sysInfo.sysId
  },
  getSysNo: state => {
    return state.sysInfo.sysNo
  },
  getSysTitle: state => {
    return state.sysInfo.tytle
  },
  getSetting: state => {
    return state.settingInfo
  },
  getEnrollInfo: state => {
    return state.enrollInfo
  },
  getOptionFlag: state => {
    return state.optionFlag
  },
  getOptionId: state => {
    return state.optionId
  }
}

const actions = {
  setSysInfo ({ commit }, obj) {
    //console.log('setSysInfo', obj)
    commit(types.SET_SYS, obj)
  },
  setSysNo ({ commit }, obj) {
    //console.log('setSysNo', obj)
    commit(types.SET_SYSNO, obj)
  },
  setSysId ({ commit }, obj) {
    //console.log('setSysId', obj)
    commit(types.SET_SYSID, obj)
  },
  setSysTitle ({ commit }, obj) {
    //console.log('setSysTitle', obj)
    commit(types.SET_SYSTITLE, obj)
  },
  setSetting ({ commit }, obj) {
    //console.log('setSetting', obj)
    commit(types.SET_SETTING, obj)
  },
  setEnrollInfo ({ commit }, obj) {
    commit(types.SET_ENROLL, obj)
  },
  setOptionFlag ({ commit }, obj) {
    commit(types.SET_OPTIONFLAG, obj)
  },
  setOptionId ({ commit }, obj) {
    commit(types.SET_OPTIONID, obj)
  }
}

const mutations = {
  // 更新 System Info
  [types.SET_SYS] (state, obj) {
    state.sysInfo = obj
  },
  // 更新 Setting Info
  [types.SET_SETTING] (state, obj) {
    state.settingInfo = obj
  },
  // 更新 Setting Info
  [types.SET_ENROLL] (state, obj) {
    state.enrollInfo = obj
  },
  [types.SET_SYSNO] (state, region) {
    state.sysInfo.sysNo = region
  },
  [types.SET_SYSID] (state, keyword) {
    state.sysInfo.sysId = keyword
  },
  [types.SET_SYSTITLE] (state, keyword) {
    state.sysInfo.tytle = keyword
  },
  [types.SET_OPTIONFLAG] (state, keyword) {
    state.optionFlag = keyword
  },
  [types.SET_OPTIONID] (state, keyword) {
    state.optionId = keyword
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js